import classNames from 'classnames';
import styles from './ArticleAuthor.module.scss';
import { UI_Link, UI_LinkProps } from 'ui/components/1-atoms/Action/Link/Link';
import { UI_Picture } from 'ui/components/1-atoms/Media/Picture/Picture';
import { UI_Icon } from 'ui/components/1-atoms/Media/Icon/Icon';
import MailIcon from 'ui/icons/icon_mail.svg';
import LinkedInIcon from 'ui/icons/icon_linkedin.svg';
import { UI_Paragraph } from 'ui/components/1-atoms/Paragraph/Paragraph';


const BIO_MAX_CHARS = 320;

// The Person type caps bio at 320 characters, but values saved before the cap can be longer.
// Trim those on a word boundary so a legacy bio can't stretch the author sidebar.
const truncateBio = (bio: string): string => {
	if (bio.length <= BIO_MAX_CHARS) return bio;

	const clipped = bio.slice(0, BIO_MAX_CHARS - 1);
	const lastSpace = clipped.lastIndexOf(' ');

	return `${(lastSpace > 0 ? clipped.slice(0, lastSpace) : clipped).replace(/[\s.,;:]+$/, '')}…`;
};

export interface UI_ArticleAuthorProps {
	className?: string;
	fullName?: string;
	workTitle?: string;
	email: string;
	bio?: string;
	showArticleAuthorsBio?: boolean;
	linkedIn?: UI_LinkProps;
	image?: {
		url: string;
		altText: string;
		focalPoint?: { left: number; top: number };
		fileType?: string;
	};
	showAuthorsBio?: boolean;
}

export const UI_ArticleAuthor = ({
	className,
	fullName,
	workTitle,
	email,
	linkedIn,
	image,
	bio,
	showArticleAuthorsBio,
	showAuthorsBio,
}: UI_ArticleAuthorProps) => {
	return (
		<div className={classNames(styles.ArticleAuthor, className)}>
			<div className={styles.ArticleAuthor_imageAndSocial}>
				{image.url && (
					<div className={styles.ArticleAuthor_image}>
						<UI_Picture
							imageCropping="cover"
							url={image.url}
							altText={image.altText}
							roundBorder={true}
							sizes="80px"
							focalPoint={image.focalPoint}
							fileType={image.fileType}
						/>
					</div>
				)}
				<div className={styles.ArticleAuthor_social}>
					{email && (
						<UI_Link className={classNames(styles.ArticleAuthor_email)} href={`mailto:${email}`}>
							<UI_Icon size="xl">
								<MailIcon />
							</UI_Icon>
						</UI_Link>
					)}

					{linkedIn && (
						<UI_Link className={styles.ArticleAuthor_soMe} target={linkedIn.target} href={linkedIn.href}>
							<UI_Icon size="xl">
								<LinkedInIcon />
							</UI_Icon>
						</UI_Link>
					)}
				</div>
			</div>

			{fullName && (
				<UI_Paragraph bold className={styles.ArticleAuthor_name}>
					{fullName}
				</UI_Paragraph>
			)}
			{workTitle && <UI_Paragraph className={styles.ArticleAuthor_title}>{workTitle}</UI_Paragraph>}
			{bio && (showArticleAuthorsBio || showAuthorsBio) && <UI_Paragraph className={styles.ArticleAuthor_bio}>{truncateBio(bio)}</UI_Paragraph>}
		</div>
	);
};
